"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REDUX_REDUCER_DEFINE_STATE_KEY = "ReduxReducerDefined";
exports.REDUX_GLOBAL_STATE_KEY = "ReduxStateData";
exports.REDUX_GLOBAL_LISTEN_KEY = "ReduxStateListener";
